import { Component } from '@angular/core';
import { AlarmTableHeaderComponent } from '@components/alarm-table-header/alarm-table-header.component';

@Component({
    selector: 'app-operation-table-header',
    templateUrl: './operation-table-header.component.html',
    styleUrls: [
        './operation-table-header.component.css',
        '../alarm-table-header/alarm-table-header.component.scss',
    ],
    standalone: false
})
export class OperationTableHeaderComponent extends AlarmTableHeaderComponent {}
